var React = require('react');

function AccordionClosedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#","d":"M38.403 37.17V.315H1.547v3h31.769L.008 36.622l2.12 2.122L35.404 5.47v31.7z"}));
}

AccordionClosedInline.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39"};

module.exports = AccordionClosedInline;

AccordionClosedInline.default = AccordionClosedInline;
